import {
  isEmailVerified,
  useFirebaseAuthUserContext,
} from '@libraries/firebase';
import { Loading, getLogInRoute } from '@shared';
import { getQueryParamValue } from '@utils';
import { useRouter } from 'next/router';
import { VerifyEmailPage } from '../components/VerifyEmailMessage';

interface AuthGuardProps {
  children: React.ReactNode;
}

/** Blocks a component from rendering unless the user is signed in. */
export function AuthGuard({ children }: AuthGuardProps) {
  const { isLoading, user } = useFirebaseAuthUserContext();
  const router = useRouter();
  const redirectTo = router.pathname;
  const emailVerifiedQP = getQueryParamValue(router.query.verified);

  if (isLoading) {
    return <Loading />;
  }

  if (!user) {
    router.push(getLogInRoute(redirectTo, emailVerifiedQP === '1'));

    return null;
  }

  if (!isEmailVerified(user)) {
    return <VerifyEmailPage user={user} redirectTo={redirectTo} />;
  }

  return <>{children}</>;
}
